import { css } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';

import { MEDIA_MIN_MD, MEDIA_MIN_XS } from '_assets/css/breakpoints';

export const requestContainerStyles = css`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: var(${DesignToken.ContentBasicPrimary});
`;

export const mainContentContainerStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  ${MEDIA_MIN_XS} {
    justify-content: center;
    flex-grow: 2;
  }
`;

export const headerContainerStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: var(${SpacingToken.Spacing9}) 0 0 0;

  ${MEDIA_MIN_XS} {
    flex-direction: row;
  }

  ${MEDIA_MIN_MD} {
    margin: 0;
  }
`;

export const headerTextStyles = css`
  margin: 0 var(${SpacingToken.Spacing2}) 0;
`;

export const mainTextStyles = css`
  margin-top: var(${SpacingToken.Spacing3});
  margin-bottom: var(${SpacingToken.Spacing7});
  max-width: 240px;

  ${MEDIA_MIN_XS} {
    max-width: 100%;
  }
`;

export const logInTextStyles = css`
  margin-bottom: var(${SpacingToken.Spacing3});
  margin-top: var(${SpacingToken.Spacing12});
`;

export const productButtonsContainerStyles = css`
  display: flex;
  flex-direction: column;

  ${MEDIA_MIN_MD} {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: var(${SpacingToken.Spacing4});
  }
`;

export const productButtonStyles = css`
  display: flex;
  align-items: center;
  margin-bottom: var(${SpacingToken.Spacing3});

  > div {
    display: flex;
    align-items: center;
    gap: var(${SpacingToken.Spacing1});
  }
`;
